export default __webpack_public_path__ + "static/media/login_image.26a11d8e.svg";